export function hideInterface({
  startingThreshold = 100,
  scrollingThreshold = 10,
  showEventName = 'show-interface',
  hiddenClassName = 'is-interface-hidden',
  shownClassName = 'is-interface-shown',
  parentElement = document.body,
} = {}) {
  let prevPosition = window.scrollY;

  const hide = () => {
    parentElement.classList.add(hiddenClassName);
    parentElement.classList.remove(shownClassName);
  };
  const show = () => {
    parentElement.classList.add(shownClassName);
    parentElement.classList.remove(hiddenClassName);
  };

  const handleScrolling = () => {
    const position = window.scrollY;
    const isScrollingDown = position > prevPosition;
    prevPosition = position;

    if (position < startingThreshold) {
      show();
      return;
    }

    if (isScrollingDown) {
      hide();
    } else {
      show();
    }
  };
  handleScrolling();

  window.addEventListener('scroll', handleScrolling);
  window.addEventListener(showEventName, show);
}
